type SectionHeaderProps = {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  dark?: boolean;
};

export function SectionHeader({ eyebrow, title, subtitle, dark = false }: SectionHeaderProps) {
  return (
    <div className={`section-header ${dark ? "section-header-dark" : ""}`}>
      {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
      <h2>{title}</h2>
      {subtitle ? <p>{subtitle}</p> : null}
    </div>
  );
}
